module.exports = __webpack_public_path__ + "static/valuation-bg-186725000a2295dc27956c82a1dae840.png";